module.exports = __webpack_public_path__ + "static/media/Geometry_1.4aaf67da.png";


//////////////////
// WEBPACK FOOTER
// ./src/Geometry_1.png
// module id = 17
// module chunks = 0